import {
  createContext,
  useState,
  useMemo,
  useContext,
  useCallback,
} from "react";
import { getBranches } from "../Services/branchService";
import { BranchContextType, IBranch } from "../@types/branch";
import { useEffectAsync } from "../Hooks/useEffectAsync";

const BranchContext = createContext<BranchContextType | null>(null);

const useBranchContext = () => {
  const context = useContext(BranchContext);
  if (context === undefined) {
    throw new Error("useBranchContext was used outside of its Provider");
  }

  return context;
};

const BranchContextProvider = ({ children }: any) => {
  const [branches, setBranches] = useState<IBranch[]>([]);
  const [branchStatus, setBranchStatus] = useState([]);
  const [credit, setCredit] = useState([]);
  const [density, setDensity] = useState([]);
  const [operatingTypes, setOperatingTypes] = useState([]);
  const [lms, setLms] = useState([]);
  const [productTypes, setproductTypes] = useState<[]>([]);
  const [legalProducts, setLegalProducts] = useState<[]>([]);
  const [underwritingTypes, setUnderwritingTypes] = useState<[]>([]);

  const load = useCallback(async () => {
    try {
      const response = await getBranches();
      if (response) {
        setBranches(response.branchHierarchy);
        setBranchStatus(response.branchStatuses);
        setCredit(response.creditBureau);
        setDensity(response.branchDensity);
        setLms(response.loanManagementSystems);
        const data = response.productTypes.map((branchProducts: any) => ({
          id: branchProducts.id.toString(),
          title: branchProducts.name,
        }));
        setproductTypes(data);
        setOperatingTypes(response.branchOperatingTypes);
        setLegalProducts(response.legalProductTypes);
        setUnderwritingTypes(response.underwritingTypes);
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffectAsync(async () => {
    await load();
  }, [load]);

  const providerValue = useMemo(
    () => ({
      branches,
      setBranches,
      branchStatus,
      setBranchStatus,
      credit,
      setCredit,
      density,
      setDensity,
      lms,
      setLms,
      productTypes,
      setbranchProducts: setproductTypes,
      load,
      operatingTypes,
      setOperatingTypes,
      legalProducts,
      setLegalProducts,
      underwritingTypes,
      setUnderwritingTypes,
    }),
    [
      branches,
      branchStatus,
      credit,
      density,
      lms,
      productTypes,
      load,
      operatingTypes,
      legalProducts,
      underwritingTypes,
    ]
  );

  return (
    <BranchContext.Provider value={providerValue}>
      {children}
    </BranchContext.Provider>
  );
};

export { BranchContext, BranchContextProvider, useBranchContext };
